import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import contact from "../../../images/undraw_profile_details_f8b7.svg";
import "./ContactSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
const ContactSection = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1500,
    });
  }, []);
  return (
    <div className="pb-16">
      <h2 className="title-design  text-2xl lg:text-4xl font-extrabold pt-12">
        Contact US
      </h2>
      <div className="px-5 xl:px-20 lg:px-20 md:px-16 sm:px-16  ">
        <div className=" contact-section-half-width  grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 justify-center ">
          <div
            data-aos="zoom-out"
            className="items-center text-center p-5 lg:pr-24"
          >
            <h2 className="text-2xl text-green-500 tracking-widest text-gray-700 pb-2 lg:pt-8 font-extrabold">
              We have Experience Management Team!
            </h2>
            <h1 className="text-2xl lg:text-6xl text-green-400 font-extrabold">
              Best Support!
            </h1>
            <hr />
            <p className="text-sm lg:text-xl pt-2 ">
              The hospital support team is a multidisciplinary team through
              which the expertise of hospice care can be extended to the acute
              hospital situation. This article highlights the aims of such a
              team and the expertise of different members, emphasizing the
              advisory role and the importance of 'role-modelling'.
            </p>
            <Link to="/contact">
              <button className="shadow rounded-lg text-white font-bold bg-green-400 p-2">
                Contact US
              </button>
            </Link>
          </div>
          <div data-aos="zoom-out-up" className="xl:pl-24 pt-16">
            <img className="w-3/4 ml-16" src={contact} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
